import UploadCircleIcon from '../../../assets/svg/upload-circle.svg?react';
import FJLocalStore from '../../../store/FJLocalStore';
import styles from './FJAudioUpload.module.less';
import { useRef, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import {
    UPLOAD_FILE_TYPE_OF_AUDIO,
    CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_AUDIOS,
} from '../../../config/dataConfig/FJGenerateData';
import classNames from 'classnames';
import FJConstant from '../../../constants/FJConstant';
import CancelWhiteIcon from '../../../assets/svg/cancel-white.svg?react';
import AddFileWhiteIcon from '../../../assets/svg/add-file-white.svg?react';
import FJUploadBorderIcon from '../../../assets/svg/upload-border-normal.svg?react';
import FJUploadBorderHoverIcon from '../../../assets/svg/gradient-border.svg?react';
import FJTextWithEllipsisParent from '../../../common/components/FJTextWithEllipsis/FJTextWithEllipsisParent';
import FJUtil from '../../../util/FJUtil';
import FJLoading from '../../components/FJLoading/FJLoading.jsx';
import FJMusicPlayIcon from '../../../assets/svg/play-gradual.svg?react';
import FJMusicPauseIcon from '../../../assets/svg/pause-gradual.svg?react';
import FJAudioWave from '../../components/FJAudioWave/FJAudioWave.jsx';
import UploadImgIcon from '../../../assets/svg/music-upload.svg?react';
import FJButton from '../../components/FJButton/FJButton.jsx';
import FJAudioPlayManager from '../../../store/FJAudioPlayManager.js';
import FJAudioWaveImgUpload from '../../components/FJAudioWave/FJAudioWaveImgUpload.jsx';

const EmptyComponent = props => {
    const { children, isBigComponent, uploadDesc } = props;
    return (
        <div className={styles.empty_box}>
            {!isBigComponent ? (
                <>
                    <UploadCircleIcon className={styles.upload_icon} />
                    <div
                        className={styles.upload_text}
                        dangerouslySetInnerHTML={{
                            __html: uploadDesc || FJLocalStore._('upload-music'),
                        }}
                    />
                </>
            ) : (
                <div className={styles.big_empty}>
                    <UploadImgIcon />
                    <div className={styles.text}>{FJLocalStore._('click-or-drag-to-upload')}</div>
                    <FJButton type='gradient' text='upload-music' className={styles.btn} />
                </div>
            )}

            {children}
        </div>
    );
};

const FJAudioUpload = props => {
    const {
        uploadFile,
        uploadStatus = FJConstant.DEFAULT,
        isBigComponent = false,
        isDraggingFile,
        setIsDraggingFile,
        showAIImageHistoryList,
        openMediaLibrary,
        onDelete,
        audioInfo,
        className,
        config = {},
        uploadDesc,
    } = props;
    const inputRef = useRef(null);
    const audioRef = useRef(null);
    const [isPlay, setIsPlay] = useState(false);
    const [audioDuration, setAudioDuration] = useState(null);
    const idRef = useRef(FJAudioPlayManager.createId());
    const _onUploadFile = e => {
        const file = e.target.files[0];
        uploadFile(file);
        e.target.value = null;
    };
    const _onUpload = async e => {
        e.stopPropagation();
        if (uploadStatus === FJConstant.LOADING || uploadStatus === FJConstant.SUCCESS) {
            return;
        }
        if (window.isEditPage && openMediaLibrary) {
            openMediaLibrary();
        } else if (inputRef.current) {
            inputRef.current.click();
        }
    };
    const _onDragOver = e => {
        setIsDraggingFile(true);
        e.stopPropagation();
        e.preventDefault();
    };

    const _onDragLeave = e => {
        setIsDraggingFile(false);
        e.stopPropagation();
        e.preventDefault();
    };

    const _onDragDrop = e => {
        setIsDraggingFile(false);
        e.stopPropagation();
        e.preventDefault();
        let files = e.dataTransfer.files;
        if (files && files.length > 0) {
            const file = files[0];
            setIsPlay(false);
            uploadFile(file);
        }
    };
    const _onDelete = e => {
        e.preventDefault();
        e.stopPropagation();
        setIsPlay(false);
        onDelete();
    };

    const renderEmptyUpload = () => {
        return (
            <EmptyComponent onClick={showAIImageHistoryList} isBigComponent={isBigComponent} uploadDesc={uploadDesc}>
                {renderBorder()}
            </EmptyComponent>
        );
    };

    const renderBorder = () => {
        return (
            <div className={styles.upload_border_box}>
                <FJUploadBorderIcon className={styles.upload_border} />
                <FJUploadBorderHoverIcon className={styles.upload_border_hover} />
            </div>
        );
    };

    const _changePlay = e => {
        e.stopPropagation();
        setIsPlay(!isPlay);
        if (isPlay) {
            audioRef.current.pause();
        } else {
            audioRef.current.play();
            // FJAudioPlayManager.add(idRef.current, { pause: pause });
        }
    };

    const recordPlay = useCallback(() => {
        // FJAudioPlayManager.add(idRef.current, { pause: pause });
    }, []);

    const pause = () => {
        setIsPlay(false);
        audioRef.current.pause();
    };

    const updateDuration = useCallback(duration => {
        setAudioDuration(FJUtil.formatTime(duration, false, 2));
    }, []);

    const renderSuccess = () => {
        return (
            <>
                <div className={styles.control} onClick={_changePlay}>
                    {isPlay ? <FJMusicPauseIcon /> : <FJMusicPlayIcon />}
                </div>
                <div className={styles.content_box}>
                    <div className={styles.content_header}>
                        <FJTextWithEllipsisParent className={styles.name} text={audioInfo.name} />
                        {audioDuration && <div className={styles.time}>{audioDuration}</div>}
                    </div>
                    <div className={styles.audio_content}>
                        <div className={styles.audio}>
                            {/*<FJAudioWave*/}
                            {/*    url={audioInfo.url}*/}
                            {/*    ref={audioRef}*/}
                            {/*    setIsPlay={setIsPlay}*/}
                            {/*    updateDuration={updateDuration}*/}
                            {/*    recordPlay={recordPlay}*/}
                            {/*    isPlay={isPlay}*/}
                            {/*/>*/}
                            <FJAudioWaveImgUpload
                                url={audioInfo.url}
                                ref={audioRef}
                                setIsPlay={setIsPlay}
                                updateDuration={updateDuration}
                                recordPlay={recordPlay}
                                isPlay={isPlay}
                                config={{ width: 335, height: 22, ...config }}
                            />
                        </div>
                        <div className={styles.delete_icon} onClick={_onDelete}>
                            <CancelWhiteIcon />
                        </div>
                    </div>
                </div>
                {isDraggingFile && (
                    <div className={classNames(styles.filter_mask, isDraggingFile ? styles.dragging : '')}>
                        <AddFileWhiteIcon />
                        <span className={styles.filter_mask_text}>{FJLocalStore._('drag-and-drop')}</span>
                    </div>
                )}
                <div className={styles.dragging_mask}></div>
            </>
        );
    };

    const renderGenerating = () => {
        return (
            <>
                <div className={styles.preview_box}>
                    <div className={styles.loading}>
                        <FJLoading strokeColor='#A8ACBC' />
                    </div>
                </div>
                {renderBorder()}
            </>
        );
    };
    const renderMain = () => {
        switch (uploadStatus) {
            case FJConstant.DEFAULT:
                return renderEmptyUpload();
            case FJConstant.SUCCESS:
                return renderSuccess();
            default:
                return renderGenerating();
        }
    };

    return (
        <div
            className={classNames(
                styles.box,
                isDraggingFile && styles.dragging,
                isBigComponent &&
                    (uploadStatus === FJConstant.DEFAULT || uploadStatus === FJConstant.LOADING) &&
                    styles.big,
                uploadStatus === FJConstant.SUCCESS && styles.success,
                className,
            )}
            onDragOver={_onDragOver}
            onDrop={_onDragDrop}
            onDragLeave={_onDragLeave}
            onClick={_onUpload}
        >
            {renderMain()}
            <input
                type='file'
                ref={inputRef}
                accept={UPLOAD_FILE_TYPE_OF_AUDIO + CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_AUDIOS}
                className={styles.input}
                onChange={_onUploadFile}
            />
        </div>
    );
};

FJAudioUpload.propTypes = {
    uploadFile: PropTypes.func,
    isLoading: PropTypes.bool,
    isUploading: PropTypes.bool,
    uploadStatus: PropTypes.string,
    isSmallComponent: PropTypes.bool,
    originImage: PropTypes.object,
    isDraggingFile: PropTypes.bool,
    setIsDraggingFile: PropTypes.func,
    showAIImageHistoryList: PropTypes.func,
};

export default FJAudioUpload;
